import { createContext, useContext, useState } from 'react';

// Criar o contexto
const CorrecaoContext = createContext();

// Provider que envolve os componentes
export const CorrecaoProvider = ({ children }) => {
  const [correcaoData, setCorrecaoData] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [arquivoOriginal, setArquivoOriginal] = useState(null);
  const [temaSelecionado, setTemaSelecionado] = useState(null);

  // Função para limpar todos os dados
  const clearCorrecaoData = () => {
    setCorrecaoData(null);
    setImageData(null);
    setArquivoOriginal(null);
    setTemaSelecionado(null);
  };

  // Função para salvar dados completos da correção
  const saveCorrecaoCompleta = (dados) => {
    setCorrecaoData(dados.correcao);
    setImageData(dados.imagem);
    setArquivoOriginal(dados.arquivo);
    setTemaSelecionado(dados.tema);
  };

  const value = {
    // Estados
    correcaoData,
    imageData,
    arquivoOriginal,
    temaSelecionado,
    
    // Setters individuais
    setCorrecaoData,
    setImageData,
    setArquivoOriginal,
    setTemaSelecionado,
    
    // Funções utilitárias
    clearCorrecaoData,
    saveCorrecaoCompleta
  };

  return (
    <CorrecaoContext.Provider value={value}>
      {children}
    </CorrecaoContext.Provider>
  );
};

// Hook customizado para usar o contexto
export const useCorrecao = () => {
  const context = useContext(CorrecaoContext);
  if (!context) {
    throw new Error('useCorrecao deve ser usado dentro de CorrecaoProvider');
  }
  return context;
};

export default CorrecaoContext;